import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { addAlert, selectLoading } from 'modules/notification'
import EditSurveyFormComponent from './editSurveyForm.component'
import { getProductDropdown } from 'modules/product-mgmt/redux/action/products.action'
import { surveyTemplate } from 'modules/survey/constants/template';
import {canAccess} from "../../../../profile/redux/selector/profile.selector";
import {AccessRights} from "../../../../../lib/constants/accessRights";

export default function EditSurveyFormContainer({
  handleSubmit,
  handleClose,
  isEditMode,
  survey,
  isLoading,
  templateType,
}) {
  const dispatch = useDispatch();
  const productDropdown = useSelector(
    (state) => state.products.productsDropdown
  );
  const isProductDropdownLoading = useSelector((state) =>
    selectLoading(state, getProductDropdown.typePrefix)
  );
  const lang = useSelector((state) => state.constant.languages);
  const [template, setTemplate] = useState();
  const [isAddQuestionOpen, setIsAddQuestionOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [surveyData, setSurveyData] = useState({
    id: "",
    name: "",
    description: "",
    productIds: [],
    startDate: moment().format("YYYY-MM-DD HH:mm"),
    endDate: moment().add(7, "day").format("YYYY-MM-DD HH:mm"),
    questions: [],
    disableStartDate: false
  })
  const [isError, setIsError] = useState("")
  const canEditName = useSelector(state => canAccess(state, AccessRights.Survey.LISTING_WRITE_UPDATE_NAME));
  const canEditDesc = useSelector(state => canAccess(state, AccessRights.Survey.LISTING_WRITE_UPDATE_DESCRIPTION));
  const canEditProduct = useSelector(state => canAccess(state, AccessRights.Survey.LISTING_WRITE_UPDATE_ASSIGN_PRODUCT));
  const canEditPeriod = useSelector(state => canAccess(state, AccessRights.Survey.LISTING_WRITE_UPDATE_PERIOD));
  const canEditQuestion = useSelector(state => canAccess(state, AccessRights.Survey.LISTING_WRITE_UPDATE_QUESTION));
  const canUseVoucher = useSelector(state => canAccess(state, AccessRights.Survey.VOUCHER));

  const alertWarningMessage = (message) => {
    dispatch(addAlert({ severity: "warning", message }));
  };

  const handleSubmitWithDebounce = async (surveyData, isError) => {
    try {
      await handleSubmit(surveyData, isError);
    } finally {
      setIsSubmitting(true);
    }
  }

  useEffect(() => {
    if (templateType) {
      setTemplate(surveyTemplate(lang).find((x) => x.type === templateType));
    }

    // if (!isEditMode && canUseVoucher) {
    //   setTemplate(surveyTemplate(lang).find(x => x.type === surveyTemplateType.voucher));
    // }
  }, [templateType, lang, isEditMode, canUseVoucher]);

  useEffect(() => {
    if (template) {
      setSurveyData((prev) => ({
        ...prev,
        name: template.name,
        description: template.description,
        questions: [...template.questions],
      }));
    }

    if (isEditMode) {
      setSurveyData((prev) => ({
        ...prev,
        id: survey.id,
        name: survey.name,
        description: survey.description,
        productIds: [...survey.productIds],
        startDate: survey.startDate,
        endDate: survey.endDate,
        questions: [...survey.questions],
        disableStartDate: moment(survey.startDate).isBefore(moment()),
      }));
    }
  }, [template, isEditMode, survey]);

  const handleDeleteQuestion = (index) => {
    let questionsTemp = [...surveyData.questions];

    questionsTemp.splice(index, 1);

    setSurveyData((prev) => ({
      ...prev,
      questions: questionsTemp,
    }));
  };

  const handleIsAddQuestionOpen = (value) => {
    setIsAddQuestionOpen(value);
  };

  return (
    <EditSurveyFormComponent
      alertWarningMessage={alertWarningMessage}
      handleSubmit={handleSubmitWithDebounce}
      handleClose={handleClose}
      isEditMode={isEditMode}
      isLoading={isLoading}
      isSubmitting={isSubmitting}
      productDropdown={productDropdown}
      isProductDropdownLoading={isProductDropdownLoading}
      lang={lang}
      handleDeleteQuestion={handleDeleteQuestion}
      isAddQuestionOpen={isAddQuestionOpen}
      handleIsAddQuestionOpen={handleIsAddQuestionOpen}
      surveyData={surveyData}
      setSurveyData={setSurveyData}
      isError={isError}
      setIsError={setIsError}
      canEditName={canEditName}
      canEditDesc={canEditDesc}
      canEditProduct={canEditProduct}
      canEditPeriod={canEditPeriod}
      canEditQuestion={canEditQuestion}
    />
  );
}
